<template>
  <div>
    <BaseHeadline
      icon="mdi-file-document"
      :showOnMobile="true"
      :breadcrumbs="breadcrumbsData"
      :showBreadcrumbsOnMobile="true"
    >
      <template v-slot:headlineBtns>
        <v-btn
          v-if="$route.name !== 'ProjectDocuments' && !isTrysilhus && canUpload"
          color="primary"
          depressed
          @click="addFile"
        >
          <v-icon :left="!$vuetify.breakpoint.mobile">mdi-plus</v-icon>
          {{ !$vuetify.breakpoint.mobile ? "Legg til fil" : "" }}
        </v-btn>
        <v-btn
          v-if="documentsSelected.length > 0"
          color="secondary"
          depressed
          @click="downloadMerged"
          class="mr-2"
        >
          <v-icon :left="!$vuetify.breakpoint.mobile">mdi-download</v-icon>
          {{ !$vuetify.breakpoint.mobile ? "Last ned valgte" : "" }}
        </v-btn>
      </template>
    </BaseHeadline>

    <input
      v-show="false"
      ref="uploadSingle"
      accept="image/*, .pdf, .doc, .docx, .xlsx, .xls, .msg"
      type="file"
      @change="updateDialog"
    />

    <input
      v-show="false"
      ref="uploadMultiple"
      accept="image/*, .pdf, .doc, .docx, .xlsx, .xls, .msg"
      type="file"
      multiple
      @change="updateDialog"
    />

    <v-checkbox
      v-if="displaySelection"
      v-model="allSelected"
      indeterminate
      @change="handleAllSelected"
      label="Velg alle PDF-dokumenter"
      class="mx-4"
    ></v-checkbox>

    <DocumentsList
      :documents="documents"
      :loading="loading"
      @click="clickBtn"
      @selection="selectedChanged"
    >
      <template v-slot="{ document }">
        <v-btn
          v-if="
            document.applicationType &&
            !isTrysilhus &&
            document.canUploadVersion
          "
          icon
          @click.stop="uploadNewDocument(document)"
        >
          <v-icon>mdi-upload</v-icon>
        </v-btn>
      </template>
    </DocumentsList>

    <DocumentsChangeSummaryDialog
      v-model="showDialog"
      :title="titleSummary"
      :subtitle="subtitleSummary"
      :textLabel="textLabelSummary"
      :btnActionName="btnActionName"
      :updateFile="updateFile"
      @upload="updateVersion"
      @close="close"
    />

    <UplodeDocumentsStatusDialogVue
      v-model="showStatusDialog"
      :statusList="statusList"
    />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import BaseHeadline from "@/components/shared/BaseHeadline.vue";
import documentApi from "@/api/documentApi";
import { Breadcrumbs, ProjectObject } from "@/types/interface";
import { mapGetters } from "vuex";

import {
  DocumentObject,
  DocumentsBreadcrumbs,
} from "@/types/documentInterface";

import DocumentsList from "@/components/shared/documents/DocumentsList.vue";
import DocumentsChangeSummaryDialog from "@/components/shared/documents/DocumentsChangeSummaryDialog.vue";
import notification from "@/helpers/notification";
import UplodeDocumentsStatusDialogVue from "../children/UplodeDocumentsStatusDialog.vue";

export default Vue.extend({
  data() {
    return {
      loading: true,
      project: {} as ProjectObject,
      documents: new Array<DocumentObject>(),
      documentsSelected: new Array<DocumentObject>(),
      breadcrumbs: new Array<DocumentsBreadcrumbs>(),
      oldDocument: {} as DocumentObject | null,
      showDialog: false,
      formData: null as null | FormData | undefined,
      file: null as any,
      canUpload: false,
      titleSummary: "",
      subtitleSummary: "",
      textLabelSummary: "",
      btnActionName: "",
      updateFile: false,
      timmer: null as any,
      displaySelection: false,
      allSelected: false,
      showStatusDialog: false,
      statusList: [],
    };
  },
  async created() {
    await this.fetchData();
  },

  watch: {
    $route() {
      this.fetchData();
    },
  },

  methods: {
    async fetchData() {
      this.loading = true;
      this.allSelected = false;
      this.displaySelection = false;
      this.documentsSelected = [];
      this.documents = [];
      if (this.$route.name === "ProjectDocumentsWithUuid") {
        await documentApi
          .getFolderDocuments(this.$route.params.id, this.$route.params.uuid)
          .then((repsonse) => {
            this.documents = this.sortDocuments(repsonse.documents);
            this.displaySelection =
              this.documents.filter((d) => d.extension === ".pdf").length > 0;
            this.breadcrumbs = repsonse.breadCrumbs;
            this.canUpload = repsonse.canUpload;
            this.loading = false;
            this.project = repsonse.project;
          })
          .catch(() => {
            this.loading = false;
            this.$router.push({ name: "Dashboard" });
          });
      } else {
        await documentApi
          .getDocuments(this.$route.params.id)
          .then((repsonse) => {
            this.documents = this.sortDocuments(repsonse.documents);
            this.displaySelection =
              this.documents.filter((d) => d.extension === ".pdf").length > 0;
            this.breadcrumbs = repsonse.breadCrumbs;
            this.loading = false;
            this.project = repsonse.project;
          })
          .catch(() => {
            this.loading = false;
            this.$router.push({ name: "Dashboard" });
          });
      }
    },
    sortDocuments(documents) {
      var folders = documents.filter((x) => !x.applicationType);
      var files = documents.filter((x) => x.applicationType);

      return [...folders, ...files];
    },
    clickBtn(document: DocumentObject) {
      if (!document.applicationType) {
        //Is folder
        this.$router.push({
          name: "ProjectDocumentsWithUuid",
          params: { uuid: document.uuid },
        });
      } else {
        if (this.isKiosk) {
          switch (document.extension) {
            case ".doc":
            case ".docx":
            case ".xls":
            case ".xlsx":
              documentApi.convertToPdfDocument(document);
              break;
            case ".pdf":
              documentApi.downloadDocument(document);
              break;
            default:
              if (document.applicationType.includes("image")) {
                documentApi.downloadDocument(document);
              } else {
                notification.warn(
                  "Vi støtter ikke denne typen fil på kiosk, bruk mobilen eller pcen for å åpne denne filen!"
                );
              }
          }
        } else {
          documentApi.downloadDocument(document);
        }
      }
    },
    downloadMerged() {
      var fileName = "";
      if (this.documentsSelected.length > 1) {
        this.breadcrumbs.forEach((bc) => {
          fileName += bc.title;
          if (!bc.last) {
            fileName += "_";
          }
        });
        fileName = fileName.replaceAll(" ", "_");
        fileName += ".pdf";
      } else {
        fileName = this.documentsSelected[0].name;
      }
      documentApi.downloadMergedPdfs(this.documentsSelected, fileName);
    },
    addFile() {
      //No old documetn when adding
      this.oldDocument = null;

      clearTimeout(this.timmer);
      this.timmer = setTimeout(() => {
        (this.$refs.uploadMultiple as HTMLElement).click();
      }, 100);
    },
    uploadNewDocument(oldDocument: DocumentObject) {
      //save old document. Uses uuid to update
      this.oldDocument = oldDocument;

      clearTimeout(this.timmer);
      this.timmer = setTimeout(() => {
        (this.$refs.uploadSingle as HTMLElement).click();
      }, 100);
    },
    async updateDialog(newFile: any) {
      //Create docuemt for uploading
      if (newFile.currentTarget && newFile.currentTarget.files.length > 1) {
        newFile = newFile.currentTarget.files;
      } else {
        newFile = newFile.currentTarget.files[0];
      }
      this.file = newFile;

      if (!this.oldDocument) {
        this.titleSummary = "Nytt dokument";
        this.subtitleSummary = "Legg til kommentar nytt dokument";
        this.textLabelSummary = "Beskrivelse/Tegningsnummer/Navn";
        this.btnActionName = "Last opp dokument";
        this.updateFile = false;
      } else {
        this.titleSummary = "Endringsmelding";
        this.subtitleSummary = "Legg til endringsmelding/revisjonsnummer";
        this.textLabelSummary = "Endringsmelding/revisjonsnummer";
        this.btnActionName = "Last opp ny versjon";
        this.updateFile = true;
      }

      this.showDialog = true;
    },
    async updateVersion({ text, useOldName }) {
      this.formData = new FormData();
      var name = "";

      text = this.profile.person.fullName + ": " + text;
      this.formData?.append("changeSummary", text);

      if (!this.oldDocument) {
        //upload new
        if (this.file.length > 1) {
          for (let i = 0; i < this.file.length; i++) {
            this.formData.append("files", this.file[i]);
          }
        } else {
          this.formData.append("files", this.file);
        }

        await documentApi
          .uploadDocument(
            this.$route.params.id,
            this.$route.params.uuid,
            this.formData
          )
          .then((repsonse: any) => {
            this.statusList = repsonse.statusList;
            this.showStatusDialog = true;

            this.documents = this.sortDocuments(repsonse.documents);
            this.breadcrumbs = repsonse.breadCrumbs;
            this.showDialog = false;
            this.upload.value = null;
            if (repsonse.error && repsonse.error.length > 1) {
              notification.warn(repsonse.error);
            }
          })
          .catch(() => {
            this.showDialog = false;
            this.upload.value = null;
          });
      } else {
        //upload new version
        if (useOldName) {
          var re = /(?:\.([^.]+))?$/;
          var ext = (re as any).exec(this.file.name)[0];
          name = this.oldDocument?.name.replace(/\.[^/.]+$/, "") + ext;
          this.formData.append("file", this.file, name);
        } else {
          this.formData.append("file", this.file);
        }

        await documentApi
          .updateDocument(this.oldDocument?.uuid, this.formData)
          .then(() => {
            window.location.reload();
            //(this as any).oldDocument.name = useOldName ? name : this.file.name;

            this.showDialog = false;
            this.upload.value = null;
          })
          .catch(() => {
            this.showDialog = false;
            this.upload.value = null;
          });
      }
    },
    close() {
      this.upload.value = null;
    },
    async selectedChanged(document: DocumentObject) {
      var docs = this.documents;
      var doc = docs.find((d) => d.uuid == document.uuid) as DocumentObject;
      if (doc) {
        doc.selected = document.selected;
      }
      this.documents = [...docs];
      this.documentsSelected = this.documents.filter((d) => d.selected);
      this.allSelected = this.documents.findIndex((d) => !d.selected) === -1;
    },
    async handleAllSelected() {
      var docs = this.documents;
      docs.forEach((doc: any) => {
        doc.selected = this.allSelected;
      });
      this.documents = [...docs];
      this.documentsSelected = this.documents.filter((d) => d.selected);
    },
  },

  computed: {
    ...mapGetters({
      profile: "shared/profile",
      isTrysilhus: "shared/isTrysilhus",
      isKiosk: "shared/isKiosk",
    }),
    breadcrumbsData(): Array<Breadcrumbs> {
      if (this.breadcrumbs && this.project) {
        var data = this.breadcrumbs.map((x) => {
          return {
            disabled: x.last,
            text: x.title,
            to: x.id
              ? {
                  name: "ProjectDocumentsWithUuid",
                  params: { uuid: x.id },
                }
              : {
                  name: "ProjectDocuments",
                  params: { id: this.$route.params.id },
                },
            exact: true,
          };
        }) as Array<Breadcrumbs>;

        //add project first in breadcrumb
        return [
          {
            disabled: false,
            text: this.project.name,
            to: {
              name: "Project",
              params: { id: this.$route.params.id },
            },
            exact: true,
          },
          ...data,
        ];
      }

      return [];
    },
    upload(): Vue & { value: string | null } {
      return this.$refs.upload as Vue & {
        value: "";
      };
    },
  },

  components: {
    BaseHeadline,
    DocumentsList,
    DocumentsChangeSummaryDialog,
    UplodeDocumentsStatusDialogVue,
  },
});
</script>

<style lang="scss">
.alertStyle {
  .v-alert__wrapper {
    .v-alert__icon.v-icon:after {
      background: transparent !important;
    }
  }
}
</style>
